export function Api(url: string) {
    const actualDecorator = (target: any): void => {
        target.url = url;
    };

    return actualDecorator;
}
